module.exports = __webpack_public_path__ + "static/media/4-normal.e1adad28.png";